/* eslint-disable max-len */
import React from 'react';
import { Add } from '@one-thd/sui-icons';
import { shape, string } from 'prop-types';

import { getGridClasses } from '../utils/ui';
import { LAUNDRY_GRID_BASE } from '../constants/index';

const LaundryAddIcon = ({ grid, className, iconClassName }) => {
  const gridClasses = getGridClasses(grid);

  return (
    <div className={`sui-block md:sui-absolute md:sui-w-full ${LAUNDRY_GRID_BASE} ${gridClasses} ${className} sui-pointer-events-none`}>
      <div className={`md:sui-col-span-1 md:sui-w-full md:sui-aspect-square md:sui-flex md:sui-justify-center md:sui-items-center lg:sui-col-span-1 ${iconClassName}`}>
        <Add size="small" />
      </div>
    </div>
  );
};

LaundryAddIcon.defaultProps = {
  grid: shape({}),
  className: '',
  iconClassName: ''
};

LaundryAddIcon.propTypes = {
  grid: null,
  className: string,
  iconClassName: string
};

export default LaundryAddIcon;